import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, PaymentMethod } from './types'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
  code?: string
}

const getSlice = (slice: PaymentMethod): PaymentMethod => {
  return slice ?? {}
}

const slice = createSlice({
  name: 'quote/paymentMethod',
  initialState,
  reducers: {
    setPaymentMethod (state, action: PayloadAction<ActionData>) {
      const { cartId, code } = action.payload
      const slice = getSlice(state[cartId])
      slice.initialized = undefined
      slice.code = code
      state[cartId] = slice
    },

    initPaymentMethod (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.initialized = Date.now()
      state[cartId] = slice
    }
  }
})

export const reducer = slice.reducer

export const { setPaymentMethod, initPaymentMethod } = slice.actions
